<div class="shadow-box flex flex-col items-center max-w-screen-sm mb-4">
    <h3>Demo-Modus</h3>
    <p>Viel Spaß beim Ausprobieren der KnOot App! Um Vollzugang zu bekommen, such dir den passenden Kurs auf der <a routerLink="/kurse">Kursseite</a> aus!</p>
</div>